<template>
	<label class="container">
		<input
			ref="input"
			class="checkbox"
			data-test="check-box"
			type="checkbox"
			:checked="checked"
			:disabled="disabled"
			:aria-checked="checked"
			:aria-label="ariaLabel"
			@change="handleChange($event)"
		/>
		<span role="checkbox" class="custom-checkbox"></span>
	</label>
</template>

<script>
export default {
	name: 'CheckBox',
	props: {
		checked: Boolean,
		disabled: {
			type: Boolean,
			default: false,
		},
		ariaLabel: String,
	},
	methods: {
		handleChange(event) {
			this.$emit('onClick', event.target.checked);
		},
		/* when a user selects a checkbox then clicks reset before 1 second has passed
		this prevents the checkbox from showing as checked when in the state it is
		not checked */
		reset() {
			this.$refs.input.checked = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	position: relative;
	cursor: pointer;

	.checkbox {
		/* Hide the browser's default checkbox */
		position: absolute;
		opacity: 0;
		display: none;

		/* When the checkbox is checked, add a blue background & display custom checkmark */
		&:checked {
			& ~ .custom-checkbox {
				background-color: $brand-blue;
				&:after {
					display: block;
				}
			}
		}
		&:disabled {
			& ~ .custom-checkbox {
				background-color: $b360-color--gray__darker;
				cursor: not-allowed;
			}
		}
	}

	/* Create a custom checkbox */
	.custom-checkbox {
		position: absolute;
		top: -10px;
		left: 0;
		width: 18px;
		height: 18px;
		background: $white;
		border-radius: 6px;
		border: 1px solid $border-color-light;

		/* Create the checkmark and hide it when not checked */
		&:after {
			content: '';
			position: absolute;
			display: none;
			width: 4px;
			height: 9px;
			border: solid $white;
			border-width: 0 2px 2px 0;
			transform: rotate(45deg);
			left: 5.5px;
			top: 2px;
		}
	}

	/* On mouse-over, add a blue border color to custom-checkbox */
	&:hover {
		.custom-checkbox {
			border-color: $brand-blue;
		}
	}
}
</style>
